import { render, staticRenderFns } from "./Box7-1.vue?vue&type=template&id=6e6edb48&scoped=true&"
import script from "./Box7-1.vue?vue&type=script&lang=js&"
export * from "./Box7-1.vue?vue&type=script&lang=js&"
import style0 from "./Box7-1.vue?vue&type=style&index=0&id=6e6edb48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6edb48",
  null
  
)

export default component.exports